import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router } from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';
const breadcrumb: any[] = [
    {
        title: 'Home'

    },
    {
        title: 'Check Sheet setting'
    }
];

@Component({
    selector: 'page-check-sheet-setting',
    templateUrl: './check-sheet-setting.html',
    styleUrls: ['./check-sheet-setting.scss']
})

export class PageCheckSheetSetting implements OnInit {
    //initial & Search
    pageTitle: string = environment.sysName;
    breadcrumb: any[] = breadcrumb;
    loadingIndicator: boolean = true;
    key: any = "";

    filtered: any;
    ctrl: FormControl;
    autoItems = [];
    searchId: String;

    filteredSpec: any;
    filteredPart:any;
    ctrlSpec: FormControl;
    ctrlPart:FormControl;
    autoItemsSpec = [];
    autoItemsPart = [];
    specId: String = null;
    partId:String=null;

    //form
    form: FormGroup;
    selectedLineCtrl = new FormControl();
    selectedProcessCtrl = new FormControl();
    selectedSymbolCtrl = new FormControl();
    id: String;
    arrProcess = []; arrlines = [];arrParts=[];

    ckedit: boolean = false;
    //upload
    fileupload: string;
    //data table
    data: any;
    rows = []; temp = [];
    //upload file
    imageSrc: any;
    urlApi = environment.url + "/api/uploadToServerDir.php";
    Name: string;
    myFile: File; /* property of File type */
    picture: String = null; controlItemId: String = null;
    //dialog
    dialogRefWarning: MdDialogRef<WarningCheckSheetSettingDialog>;
    dialogRef: MdDialogRef<checkSheetSettingDialog>;
    setId: any;
    pdCheck:boolean=false;qcCheck:boolean=false;
    desInput:boolean=false;controlInput:boolean=false;
    sysPath:String=environment.sysPath;symbols=[];
    sysPathPrint:String=environment.sysPath+"/api/control-check-sheet-list-print.php";
    sysPathExport:String=environment.sysPath+"/api/control-check-sheet-list-export.php";
    constructor(private fb: FormBuilder, private httpservice: httpservice, private router: Router, public dialog: MdDialog, private _sharedService: SharedService) {
        this.getAutocompleteSearch();
        this.getAutocompleteSpecSearch();
        this.getAutocompletePartSearch();
        this.getLine();
        this.getStartData();
        this.getSymbol();
        this._sharedService.emitChange(this.pageTitle);
    }
    getSymbol(){
        this.httpservice.fetchget('getJSON_symbol.php?', (data) => {
            this.symbols = data;
           
        });
    }

    getAutocompleteSearch() {
        this.httpservice.fetchget('getJSON_check_sheet_item.php?', (data) => {
            this.autoItems = data;
            console.log('------auto complete------', this.autoItems);
        });
        this.ctrl = new FormControl();
        this.filtered = this.ctrl.valueChanges
            .startWith(null)
            .map(val => {
                if (isArray(val)) {
                    this.key = val[0];
                    //this.poCtrl.setValue(val[0]);
                } else {
                    this.key = val;
                    //this.poCtrl.setValue(val);
                }
                console.log('------val------', this.key);
                return val ? this.autoItems.filter((s) => new RegExp(val, 'gi').test(s.tb106f_name)) : this.autoItems;
            });
    }

    getAutocompleteSpecSearch() {
        
        this.httpservice.fetchget('getJSON_product_standard.php?', (data) => {
            this.autoItemsSpec = data;
            console.log('------auto complet ------', this.autoItemsSpec);
        });
        this.ctrlSpec = new FormControl();
        this.filteredSpec = this.ctrlSpec.valueChanges
            .startWith(null)
            .map(val => {
                this.specId =null;
                if (isArray(val)) {
                    this.key = val[0];
                    //this.poCtrl.setValue(val[0]);
                } else {
                    this.key = val;
                    //this.poCtrl.setValue(val);
                }
                console.log('------val------', this.key);
                return val ? this.autoItemsSpec.filter((s) => new RegExp(val, 'gi').test(s.tb87f_name)) : this.autoItemsSpec;
            });
    }

    getAutocompletePartSearch() {
       
        this.httpservice.fetchget('getJSON_product.php?', (data) => {
            this.autoItemsPart = data;
            console.log('------auto complet ------', this.autoItemsPart);
        });
        this.ctrlPart = new FormControl();
        this.filteredPart = this.ctrlPart.valueChanges
            .startWith(null)
            .map(val => {
                this.partId=null;
                if (isArray(val)) {
                    this.key = val[0];
                    //this.poCtrl.setValue(val[0]);
                } else {
                    this.key = val;
                    //this.poCtrl.setValue(val);
                }
                console.log('------val------', this.key);
                return val ? this.autoItemsPart.filter((s) => new RegExp(val, 'gi').test(s.tp_part_no)) : this.autoItemsPart;
            });
    }
    getPartId(id: String) {
        this.partId = id;
        console.log('spec id',id);
    }

    getSpecId(id: String) {
        this.specId = id;
        console.log('spec id',id);
    }
    getSearchId(id: String) {
        this.searchId = id;
    }

    intervalGetData() {
        return setInterval(() => {
            if (this.setId.runCount > 2) {
                clearInterval(this.setId);
            }
            this.getStartData();
            console.log('------this.setId------', this.setId);
        }, 1000);
    }

    getStartData() {
        this.httpservice.fetchget('getJSON_check_sheet_item.php?', (data) => {
            this.rows = data;
            this.temp = data;
            this.loadingIndicator = false;
        });
    }


    getProcess(tpr_id: String) {
        this.httpservice.fetchget('getJSON_process_name.php?tpr_id=' + tpr_id, (data) => {
            this.arrProcess = data;
        });
    }

    getLine() {
        this.httpservice.fetchget('getJSON_line.php?', (data) => {
            this.arrlines = data;
        });
    }

    delete(id: string) {
        let val = { id: id }
        this.httpservice.fetchpost('deleteCheckSheetItem.php', val, (cb) => { });
        this.setId = this.intervalGetData();
    }

    setedit(id: string) {
        this.id = id;
        this.ckedit = true;
        this.picture = null;
        this.controlItemId = null;
        this.httpservice.fetchget('getJSON_check_sheet_item.php?id=' + id, (data) => {
            this.form.controls.name.setValue(data[0].tb106f_name);
            this.form.controls.frequency.setValue(data[0].tb106f_frequency);
            this.controlItemId = data[0].tb106f_id;
            this.selectedLineCtrl.setValue(data[0].tpr_id);
            this.selectedProcessCtrl.setValue(data[0].tpn_id);
            this.selectedSymbolCtrl.setValue(data[0].tb118f_id);
            this.ctrlSpec.setValue(data[0].tb87f_name);
            this.ctrlPart.setValue(data[0].tp_part_no);
            this.form.controls.order.setValue(data[0].tb86f_order);
            this.specId = data[0].tb87f_id;
            this.partId = data[0].tp_id;
            if(data[0].tb106f_pd=="1"){
                this.pdCheck = true;
            }else{
                this.pdCheck = false;
            }

            if(data[0].tb106f_qc=="1"){
                this.qcCheck = true;
            }else{
                this.qcCheck = false;
            }

            if(data[0].tb86f_input_check=="1"){
                this.desInput = true;
            }else{
                this.desInput = false;
            }
            if(data[0].tb106f_control=="1"){
                this.controlInput = true;
            }else{
                this.controlInput = false;
            }
            
            console.log('setEdit',data);
            this.getProcess(data[0].tpr_id);

        });

    }
    edit() {
        this.setId = this.intervalGetData();
        if (this.myFile != null) {
            this.fileupload = this.myFile.name;
        } else {
            this.fileupload = "";
        }
        this.ckedit = false;
        this.data = {
            id: this.id,
            frequency: this.form.controls.frequency.value,
            name: this.form.controls.name.value,
            tpr_id: this.selectedLineCtrl.value,
            tpn_id: this.selectedProcessCtrl.value,
            tb118f_id:this.selectedSymbolCtrl.value,
            tb87f_id: this.specId,
            tp_id: this.partId,
            qcCheck:this.qcCheck,
            pdCheck:this.pdCheck,
            desInput:this.desInput,
            controlInput:this.controlInput,
            order:this.form.controls.order.value

        }
        // insert data
        this.httpservice.fetchpost('editDataCheckSheet.php', this.data, (cb) => { });
        //upload image
        if (this.myFile != null) {
            this.uploadPhoto(this.myFile);
        }
        this.cancelEdit();

    }

    cancelEdit() {
        this.ckedit = false;
        this.selectedLineCtrl.reset();
        this.selectedProcessCtrl.reset();
        this.selectedSymbolCtrl.reset();
        this.form.reset();
        //this.filteredSpec = [];
        this.picture = null;
        this.ctrlSpec.reset();
        this.pdCheck = false;
        this.pdCheck = false;
        this.desInput = false;
        this.controlItemId = null;

    }


    save() {
        this.setId = this.intervalGetData();
        this.data = {
            frequency: this.form.controls.frequency.value,
            name: this.form.controls.name.value,
            order:this.form.controls.order.value,
            tpr_id: this.selectedLineCtrl.value,
            tpn_id: this.selectedProcessCtrl.value,
            tb87f_id: this.specId,
            tp_id: this.partId,
            qcCheck:this.qcCheck,
            pdCheck:this.pdCheck,
            desInput:this.desInput,
            tb118f_id:this.selectedSymbolCtrl.value,
            controlInput:this.controlInput
        }
        // insert data
        this.httpservice.fetchpost('insertDataCheckSheet.php', this.data, (cb) => { });
        this.cancelEdit();
    }

    search() {
        clearInterval(this.setId);
        this.httpservice.fetchget('getJSON_check_sheet_item.php?id=' + this.searchId, (data) => {
            this.rows = data;
        });
        this.ctrl.reset();
        this.key = "";
    }
    ngOnInit() {
        this.form = this.fb.group({
            name: [null, Validators.compose([Validators.required])],
            frequency: [null, Validators.compose([Validators.required])],
            order: [null, Validators.compose([Validators.required])],
            pdCheck: [null, Validators.compose([Validators.required])],
            qcCheck: [null, Validators.compose([Validators.required])],
            desInput: [null, Validators.compose([Validators.required])],
            controlInput:[null, Validators.compose([Validators.required])]
        });

    }
    attachFile(event): void {
        var reader = new FileReader();
        let _self = this;
        reader.onload = function (e) {
            _self.imageSrc = reader.result;
            console.log(_self.imageSrc);
        };
        reader.readAsDataURL(event.target.files[0]);
        this.myFile = event.target.files[0];
    }

    updateFilter(event) {
        const val = event.target.value;
        // filter our data
        const temp = this.temp.filter(function (d) {
            return d.tb106f_name.toLowerCase().indexOf(val) !== -1 || !val;
        });
        this.rows = temp;
    }
    updateFilter_(event) {
        const val = event.target.value;
        // filter our data
        const temp = this.temp.filter(function (d) {
            return d.tpr_name.toLowerCase().indexOf(val) !== -1 || !val;
        });
        this.rows = temp;
    }

    uploadPhoto(file: File) {

        var formData = new FormData();
        formData.append('file', file);
        let data = { file: file, path: "../picture/operator/" };
        var request = new XMLHttpRequest();
        request.open('POST', this.urlApi);
        request.send(formData);

        //this.httpservice.fetchpost('uploadToServerDir.php',data,(cb)=>{});
    }

    openDeleteDialog(id: string) {
        let dialogRef = this.dialog.open(checkSheetSettingDialog);
        let instance = dialogRef.componentInstance;
        instance.message = "Do you want to delete this?";
        instance.title = "Please confirm";
        dialogRef.afterClosed().subscribe(result => {
            if (result === '1') {
                this.delete(id);
            } else {
            }
        });
    }
    openEditDialog() {
        let dialogRef = this.dialog.open(checkSheetSettingDialog);
        let instance = dialogRef.componentInstance;
        instance.message = "Do you want to save?";
        instance.title = "Please confirm";
        dialogRef.afterClosed().subscribe(result => {
            //this.selectedOption = result;
            if (result === '1') {
                if (this.form.controls.name.value != null) {
                    this.edit();
                } else {
                    this.warningDialog('Please fill name');
                }
            } else {
            }
        });
    }
    openDialog() {
        let dialogRef = this.dialog.open(checkSheetSettingDialog);
        let instance = dialogRef.componentInstance;
        instance.message = "Do you want to save?";
        instance.title = "Please confirm";
        dialogRef.afterClosed().subscribe(result => {
            if (result === '1') {
                if (this.form.controls.name.value != null) {
                    this.save();
                } else {
                    this.warningDialog('Please fill in name');
                }
            } else {
            }
        });
    }

    warningDialog(message: string) {
        let dialogRef = this.dialog.open(WarningCheckSheetSettingDialog);
        let instance = dialogRef.componentInstance;
        instance.message = message;
        instance.title = "Warning";

        dialogRef.afterClosed().subscribe(result => {
            //this.selectedOption = result;

            if (result === '1') {

            } else {

            }

        });
    }
}
//dialog
@Component({
    selector: 'operator-setting-dialog',
    templateUrl: 'dialog.html',
})
export class checkSheetSettingDialog {
    title = '';
    message = '';
    constructor(public dialogRef: MdDialogRef<checkSheetSettingDialog>) { }
}

//warning
@Component({
    selector: 'warning-operator-setting-dialog',
    templateUrl: 'warning.html',
})
export class WarningCheckSheetSettingDialog {
    title = '';
    message = '';
    constructor(public dialogRefWarning: MdDialogRef<WarningCheckSheetSettingDialog>) { }
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/check-sheet-setting/check-sheet-setting.ts